import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import CreditCard from '@icons/paymentMethod/CreditCard';

import styles from './styles.module.scss';

function PrepaidCardChargeMethod() {
  return (
        <Column className={styles.container} fullWidth
                spacing={24}>
            <Text size='2xl'
                  fontWeight='bold'
                  color={colors.gray7}>
                결제 수단
            </Text>
            {/*
            <Column align='center' spacing={8}>
                <CreditCard size={52} color={colors.primary}/>
                <Text fontWeight='bold'>신용카드</Text>
            </Column>
            */}
        </Column>
  );
}

export default PrepaidCardChargeMethod;
